import { LoaderState } from '../enums/loader-state';
import { tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, timer, zip } from 'rxjs';

/**
 * Class to track a loading process with it different states
 */
export class Loader {
	state$: BehaviorSubject<LoaderState>;

	constructor() {
		// Set loaders inital status to idle
		this.state$ = new BehaviorSubject<LoaderState>(LoaderState.IDLE);
	}

	/**
	 * manually start the loading process
	 */
	startLoading() {
		this.state = LoaderState.LOADING;
	}

	/**
	 * manually stop the loading process
	 */
	stopLoading() {
		this.state = LoaderState.IDLE;
	}

	/**
	 * track loading of an observable until it's next method is called
	 *
	 * @param observable
	 * @param delay
	 */
	loadUntilNext(observable: Observable<any>, delay: number = 0): Observable<any> {
		this.state = LoaderState.LOADING;

		if (delay > 0) {
			const timeout = timer(delay);
			observable = zip(observable, timeout);
		}

		return observable.pipe(
			tap(
				() => {
					this.state = LoaderState.IDLE;
				},
				() => {
					this.state = LoaderState.ERROR;
				}
			)
		);
	}

	/**
	 * track loading of an observable until it's complete method is called
	 *
	 * @param observable
	 * @param delay
	 * @returns
	 */
	loadUntilComplete(observable: Observable<any>, delay: number = 0): Observable<any> {
		this.state = LoaderState.LOADING;

		if (delay > 0) {
			const timeout = timer(delay);
			observable = zip(observable, timeout);
		}

		return observable.pipe(
			tap(
				() => {},
				() => {
					this.state = LoaderState.ERROR;
				},
				() => {
					this.state = LoaderState.SUCCESS;
				}
			)
		);
	}

	/**
	 * Get a observable to subscribe against the loading process
	 *
	 * @returns
	 */
	getStateObservable() {
		return this.state$;
	}

	/**
	 * Setter for current state
	 *
	 * @param state
	 */
	public set state(state: LoaderState) {
		// Set timeout is necessary to avoid the `ExpressionChangedAfterItHasBeenCheckedError` error
		setTimeout(() => {
			this.state$.next(state);
		});
	}

	/**
	 * Getter for current state
	 *
	 * @param state
	 */
	public get state(): LoaderState {
		return this.state$.getValue();
	}
}
